module.exports = __webpack_public_path__ + "img/user-2.4e30650c.png";